<template>
  <div class="d-flex w-100 py-3 item" :class="{ 'bg-orange-lighter': isPlayingAudio, 'bg-green-lighter': isRecording }">
    <WordDictM class="d-lg-none" v-if="dictIdx !== -1" v-on:closeDict="closeDict" :content="ductWord" />
    <div class="icon position-relative mr-1 pointer">
      <img src="@/assets/image/ai/icon_voice.png" class="object-contain w-100" v-if="!isPlayingAudio" @click.stop="toggleTTS()">
      <img src="@/assets/image/ai/icon_voice_stop.png" class="object-contain w-100" v-if="isPlayingAudio" @click.stop="audio_stop()">
      <img src="@/assets/image/ai/loading_circle.png" class="position-absolute loading_circle" v-if="isLoadingTTS">
    </div>
    <div class="flex-1 p-1">
      <p class="m-0 p-0"><span class="m-0 p-0" v-for="(item, index) in sentenceSpliter" :key="index" :class="{ 'active': dictIdx === index, 'pointer isDictionary': isDictionary && !isRegular(item) }" @click.stop="setIdxEn(item, index)">{{ item }}<WordDict class="d-none d-lg-block" v-if="dictIdx === index" v-on:closeDict="closeDict" :content="ductWord"/></span></p>
    </div>
    <div class="d-flex">
      <div class="icon mr-3 tooltip-outer" @click="checkRecord" :class="{ 'opacity-0': !ersRecord, 'pointer': ersRecord }">
        <img src="@/assets/image/ai/icon_info_record.png" alt="" class="object-contain w-100">
        <span class="tooltiptext">{{ $t('AiHome.follow.record') }}</span>
      </div>
      <SpeechRecognition :text="textItem" v-on:emitErsResult="emitErsResult" ref="SpeechRecognition" v-on:onMyAudioPlayEnd="onMyAudioPlayEnd" />
    </div>
  </div>
</template>

<script>
  import dictApi from '@/store/library/api'
import allJs from '@/components/AiHelper/all.js'
import SpeechRecognition from '@/components/AiHelper/speech/SpeechRecognition'
import WordDict from '@/components/AiHelper/WordDict'
import WordDictM from '@/components/AiHelper/WordDictM'

export default {
  name: 'sentence_practice',
  data () {
    return {
      ductWord: null,
      dictIdx: -1,
      isLoadingTTS: false,

      ttsUrlFemale: null,
      ttsUrlMale: null,
      isPlayingAudio: false,
      isPlayingMyAudio: false,
      isRecording: false,

      sound_effect: null,

      audio_id: '',

      isDictionary: true,

      ductWord: null,
      dictIdx: -1,

      ersRecord: null
    }

  },
  props: {
    gender: {
      type: String,
      default: 'female'
    },
    textItem: {
      type: String,
      default: ''
    }
  },
  components: {
    WordDict,
    WordDictM,
    SpeechRecognition
  },
  mixins: [
    allJs
  ],
  computed: {
    sentenceSpliter () {
      if (!this.textItem) return []
      let str = this.textItem
      const pattern = /\p{L}[\p{L}\p{N}]*(?:['’\-][\p{L}\p{N}]+)*|\p{N}+|[^\p{L}\p{N}'’\-\s]|\s+/gu

      return str.match(pattern) || []
    },
    ttsUrlSwitch () {
      let self = this
      if (self.gender === 'female') {
        return self.ttsUrlFemale
      } else {
        return self.ttsUrlMale
      }
    },
    returnPlayAudioImg () {
      const iconPlay = require('@/assets/image/ai/follow_icon_play.png')
      const iconPlay_active = require('@/assets/image/ai/follow_icon_play_active.png')
      if (this.isPlayingAudio) {
        return iconPlay_active
      } else {
        return iconPlay
      }
    },
    returnPlayMyAudioImg () {
      const iconTalk = require('@/assets/image/ai/follow_icon_talk.png')
      const iconTalk_active = require('@/assets/image/ai/follow_icon_talk_active.png')
      if (this.isPlayingMyAudio) {
        return iconTalk_active
      } else {
        return iconTalk
      }
    }
  },
  watch: {
    'gender': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal && this.sound_effect) {
          this.reload()
        }
      },
      immediate: true
    }
  },
  methods: {
    emitErsResult (emitErsResult) {
      this.ersRecord = emitErsResult

      this.checkRecord()
    },
    closeDict () {
      this.ductWord = null
      this.dictIdx = -1
    },

    async setIdxEn (item, idx) {
      let self = this
      if (self.isDictionary && !self.isRegular(item)) {
        const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${item}`)
        self.dictIdx = idx
        self.ductWord = data.data
      }
    },

    isRegular (val) {
      // eslint-disable-next-line no-useless-escape
      let pattern = new RegExp(/[\p{P}\s]/u)
      if (val && val.match(pattern)) {
        return true
      }
      return false
    },

    toggleSwitch () {
      let self = this
      if (self.ttsUrlFemale && self.ttsUrlMale) {
        self.isShowPlayer = !self.isShowPlayer
      }
    },

    async toggleTTS () {
      let self = this

      if (!self.ttsUrlFemale || !self.ttsUrlMale) {
        const myName1 = () => {
          return new Promise(async(resolve) => {
            self.isLoadingTTS = true
            self.ttsUrlFemale = await self.getTTSUrl('female', self.textItem)
            self.ttsUrlMale = await self.getTTSUrl('male', self.textItem)
            if (self.ttsUrlMale && self.ttsUrlFemale) {
              resolve('Ray1')
            }
          })
        }

        Promise.race([myName1()])
        .then(() => {
          this.sound_effect = new Audio(this.ttsUrlSwitch)
        })
        .then(() => {
          // self.sound_effect.playbackRate = self.playbackRate
          self.audio_play()
          self.isLoadingTTS = false
        })
        .then(() => {
          self.audio_play()
        })
      } else {
        self.audio_play()
      }
    },
    reload () {
      this.audio_stop()

      this.sound_effect = new Audio(this.ttsUrlSwitch)
    },
    audio_play () {
      let self = this
      self.isPlayingAudio = true
      self.sound_effect.play()
      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()
      })
    },
    audio_stop () {
      let self = this
      self.isPlayingAudio = false
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
      this.updateSwalIcons()
    },
    checkRecord () {
      if (!this.ersRecord) return

      let titleText = this.$t('AiHome.follow.title_excellent')
      if (this.ersRecord.Score >= 75 && this.ersRecord.Score < 85) {
        titleText = this.$t('AiHome.follow.title_great')
      } else if (this.ersRecord.Score >= 65 && this.ersRecord.Score < 75) {
        titleText = this.$t('AiHome.follow.title_good')
      } else if (this.ersRecord.Score < 65) {
        titleText = this.$t('AiHome.follow.title_try_again')
      }

      // 🟢 建立 Map 對應字與分數
      const ersMap = new Map(
        this.ersRecord.Words.map(item => [item.Word.toLowerCase(), item.ErrorType])
      )

      const originalText = this.ersRecord.Text || ''
      // 保留標點符號與單字（含縮寫字元 ’）
      const wordsInOriginal = originalText.match(/[\w’']+|[.,!?;]/g) || []

      const htmlWords = wordsInOriginal.map(word => {
        const cleanWord = word.toLowerCase()
        const errorType = ersMap.get(cleanWord)
        let color = ''

        if (errorType !== undefined) {
          if (errorType === 'None') color = 'green'
          else if (errorType === 'Mispronunciation' || errorType === 'Monotone') color = 'orange'
          else if (errorType === 'Omission') color = 'red'
          else return ''

          return `<span style="color: ${color}; font-weight: bold;">${word}</span>`
        }
      }).join(' ')

      this.$swal({
        title: titleText,
        html: `
          <div class="d-flex justify-content-between border-b border-black align-items-end" style="border-bottom: #5A5D9B solid 1px;">
            <div style="font-size: 35px; font-weight: bold; color: #1E1E1E;border: #5A5D9B solid 1px;border-top-left-radius: 8px;border-top-right-radius: 8px;" class="px-4 py-1">${this.ersRecord.Score}</div>
            <div class="d-flex align-items-end" style="font-size: 16px; font-weight: bold;">
              <p class="mr-2"><span style="background-color: green; height: 10px; width: 10px; display: inline-block; border-radius: 50%;"></span>${this.$t('AiHome.follow.score_excellent')}</p>
              <p class="mr-2"><span style="background-color: orange; height: 10px; width: 10px; display: inline-block; border-radius: 50%;"></span>${this.$t('AiHome.follow.score_good')}</p>
              <p class="mr-2"><span style="background-color: red; height: 10px; width: 10px; display: inline-block; border-radius: 50%;"></span>${this.$t('AiHome.follow.score_needs_improvement')}</p>
            </div>
          </div>

          <div style="text-align: left; margin-top: 16px;">
            <p style="line-height: 2; font-size: 18px;">${htmlWords}</p>
          </div>

          <div style="margin-top: 20px; display: flex; justify-content: center; gap: 24px;">
            <button id="btn-play" style="border:none;background:none;cursor:pointer;">
              <img id="imgPlayAudio" src="${this.returnPlayAudioImg}" width="40" />
              <div style="font-size: 12px; margin-top: 4px;">${this.$t('AiHome.follow.play_original')}</div>
            </button>
            <button id="btn-record" style="border:none;background:none;cursor:pointer;">
              <img id="imgPlayMyAudio" src="${this.returnPlayMyAudioImg}" width="40" />
              <div style="font-size: 12px; margin-top: 4px;">${this.$t('AiHome.follow.your_record')}</div>
            </button>
          </div>
        `,
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          title: 'text-white pt-4',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          htmlContainer: 'remainPoints_swal my-3',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
          closeButton: 'top-0 right-0 position-absolute'
        },
        didOpen: () => {
          const popup = this.$swal.getPopup?.()
          const btnPlay = popup?.querySelector('#btn-play')
          const btnRecord = popup?.querySelector('#btn-record')

          btnPlay?.addEventListener('click', async () => {
            this.isPlayingAudio = true
            this.updateSwalIcons()

            await this.toggleTTS() // 播放 TTS
            this.updateSwalIcons()
          })
          btnRecord?.addEventListener('click', async () => {
            const speechRef = this.$refs.SpeechRecognition
            speechRef.record_play()
            this.isPlayingMyAudio = true
            this.updateSwalIcons()
          })
        }
      })
    },
    updateSwalIcons () {
      const imgPlayAudio = document.getElementById('imgPlayAudio')
      const imgPlayMyAudio = document.getElementById('imgPlayMyAudio')
      if (imgPlayAudio) imgPlayAudio.src = this.returnPlayAudioImg
      if (imgPlayMyAudio) imgPlayMyAudio.src = this.returnPlayMyAudioImg
    },
    onMyAudioPlayEnd () {
      this.isPlayingMyAudio = false
      this.updateSwalIcons()
    }
  }
}
</script>
<style lang="scss" scoped>
  .item {
    border-bottom: #aaa solid 1px;
  }
  .icon {
    width: 40px;
    height: 40px;
  }
  .loading_circle {
    top: 15%;
    left: 15%;
    transform: translate(-50%, -50%);
    animation: spin 2s infinite linear;
    transform-origin: center;
  }
  @keyframes spin  {
    from {
      transform: rotate(0deg);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
  p {
    white-space: pre-line;
    word-break: normal;
    margin-bottom: 0;
    span {
      position: relative;
    }
    .isDictionary {
      &:hover {
        background-color: #BBDDFF;
      }
    }
    .active {
      background-color: #BBDDFF;
    }
  }
</style>
